import React from 'react';
import styles from './YesNoQuestion.module.css';

function YesNoQuestion({ data, answer, handleAnswerChange, isMarked }) {
  const handleInputChange = (event) => {
    handleAnswerChange(data.id, event.target.value === "yes");
  };

  return (
    <div className={isMarked ? styles.marked : ''}>
      <label className={styles.label}>{data.question}</label>
      <div className={styles.radioGroup}>
        <input type="radio" name={`yesno_${data.id}`} checked={answer === true} value="yes" onChange={handleInputChange} /> Ja
        <input type="radio" name={`yesno_${data.id}`} checked={answer === false} value="no" onChange={handleInputChange} /> Nein
      </div>
    </div>
  );
}

export default YesNoQuestion;
